import appConfig from "@/appConfig";

export function listCultures(localization) {
  if (!localization) return [];
  return localization.languages.map(({ locale }) => locale);
}

export function getLocalizationStrings(localization, culture) {
  if (appConfig.localizationStringsOverride)
    return appConfig.localizationStringsOverride;

  if (!localization || !localization.languages) return {};
  const langIndex = localization.languages.findIndex(
    (l) => l.locale === culture,
  );
  if (langIndex < 0) return {};
  return localization.languages[langIndex].strings;
}

export function getLanguageNames(localization) {
  if (!localization || !localization.languages) return {};
  return localization.languages.reduce(
    (acc, { locale, name }) => ({ ...acc, [locale]: name }),
    {},
  );
}

export function migrateLegacyDateFormat(format) {
  return format.replace("DD", "dd").replace("YYYY", "yyyy");
}

export function formatKeyData(data) {
  return Object.keys(data).reduce(
    (acc, page) => ({
      ...acc,
      [page.split(".")[0]]: data[page],
    }),
    {},
  );
}
